module.exports = __webpack_public_path__ + "static/media/oae-logo-custom.a57c8ad0.svg";